import React from "react";
import click from "./click";
import classNames from "./classNames";

function InputImage({ className, field, object, save, index }) {
  const [progress, setProgress] = React.useState(0);
  const [image, setImage] = React.useState(null);
  // const value = object[field];
  const value =
    Array.isArray(object[field]) && object[field].length > index
      ? object[field][index]
      : "";
  function readImage(file) {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImage(e.target.result);
    };
    reader.readAsDataURL(file);
  }
  function onFileSelected(file) {
    readImage(file);
    const options = {
      progress: (value) => setProgress(value * 100),
    };
    save
      .execute(file, options)
      .then((result) => {
        // object[field] = result.url;
        object[field] = object[field] || [];

        object[field][index] = result.url;

        setImage(result.url);
        setProgress(0);
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  function onClick() {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "img";
    input.onchange = (e) => {
      const [file] = e.target.files;
      file && onFileSelected(file);
    };
    click(input);
  }
  return (
    <div
      className={classNames(
        "rounded-circle bg-primary d-flex position-relative cursor-pointer",
        className
      )}
      onClick={onClick}
      style={{ height: "40px", width: "40px" }}
    >
      <div className="position-absolute h-100 w-100 rounded-circle d-flex">
        <img
          className="w-100 h-100 rounded-circle m-auto"
          src={image || value}
          style={{ objectFit: "cover" }}
          alt=""
        />
      </div>
      {!(image || value) && (
        <div className="position-absolute h-100 w-100 d-flex">
          <i className="bi bi-camera fs-4 text-light m-auto"></i>
        </div>
      )}
      {progress > 0 && (
        <div className="position-absolute h-100 w-100 bg-black bg-opacity-50"></div>
      )}
      {progress > 0 && (
        <div className="position-absolute h-100 w-100 d-flex">
          <h3 className="m-auto text-white">{progress.toFixed(0)}%</h3>
        </div>
      )}
    </div>
  );

  // return /*#__PURE__*/React.createElement("div", {
  //   onClick: onClick,
  //   className: classNames("rounded-circle bg-primary d-flex position-relative cursor-pointer", className),
  //   style: {
  //     height: "40px",
  //     width: "40px",
  //   }
  // },/*#__PURE__*/React.createElement("div", {
  //   className: "position-absolute h-100 w-100 rounded-circle d-flex"
  // }, /*#__PURE__*/React.createElement("img", {
  //   className: "w-100 h-100 rounded-circle m-auto",
  //   src: image || value,
  //   style: {
  //     objectFit: "cover"
  //   }
  // })), !(image || value) && /*#__PURE__*/ /*#__PURE__*/React.createElement("div", {
  //   className: "position-absolute h-100 w-100 d-flex"
  // },
  //  /*#__PURE__*/React.createElement("i", {
  //   className: "bi bi-camera fs-4 text-light m-auto"
  // })), progress > 0 && /*#__PURE__*/React.createElement("div", {
  //   className: "position-absolute h-100 w-100 bg-black bg-opacity-50"
  // }), progress > 0 && /*#__PURE__*/React.createElement("div", {
  //   className: "position-absolute h-100 w-100 d-flex"
  // }, /*#__PURE__*/React.createElement("h3", {
  //   className: "m-auto text-white"
  // }, progress.toFixed(0), "%")));
}
export default InputImage;
